import React, { useState, useMemo } from 'react';

const categories = [
  { id: 'cereals', name: 'Cereals & Millets 🌾', examples: ['Rice 🍚', 'Wheat 🌾', 'Maize 🌽', 'Barley 🍺', 'Oats 🥣', 'Sorghum 🌿', 'Millets 🌱'] },
  { id: 'pulses', name: 'Pulses 🥘', examples: ['Lentils 🟠', 'Chickpeas 🟡', 'Pigeon Pea 🟤', 'Black Gram ⚫', 'Green Gram 🟢', 'Kidney Beans ❤️'] },
  { id: 'oilseeds', name: 'Oilseeds 🛢️', examples: ['Groundnut 🥜', 'Soybean 🌰', 'Mustard 🌻', 'Sunflower 🌻', 'Sesame 🌾'] },
  { id: 'fruits', name: 'Fruits 🍎', examples: ['Mango 🥭', 'Banana 🍌', 'Apple 🍏', 'Grapes 🍇', 'Pomegranate 🍎', 'Papaya 🥭'] },
  { id: 'vegetables', name: 'Vegetables 🥦', examples: ['Potato 🥔', 'Onion 🧅', 'Tomato 🍅', 'Cauliflower 🥬', 'Brinjal 🍆', 'Okra 🌿'] },
  { id: 'spices', name: 'Spices 🧂', examples: ['Turmeric 🌿', 'Cumin 🌾', 'Black Pepper ⚫', 'Cardamom 🌿', 'Coriander 🌿', 'Clove 🌿'] },
  { id: 'plantation', name: 'Plantation Crops 🌴', examples: ['Tea 🍵', 'Coffee ☕', 'Rubber 🟤', 'Cocoa 🍫', 'Coconut 🥥'] },
  { id: 'commercial', name: 'Commercial / Cash Crops 💰', examples: ['Sugarcane 🍬', 'Cotton 🌿', 'Tobacco 🍂', 'Jute 🌾'] },
  { id: 'livestock', name: 'Livestock & Animal 🐄', examples: ['Milk 🥛', 'Meat 🥩', 'Eggs 🥚', 'Wool 🐑'] },
  { id: 'fisheries', name: 'Fisheries & Aquaculture 🐟', examples: ['Shrimp 🍤', 'Prawn 🍤', 'Rohu 🐟', 'Catla 🐟', 'Tilapia 🐠'] },
  { id: 'forestry', name: 'Forestry 🌳', examples: ['Timber 🪵', 'Bamboo 🎋', 'Honey 🍯', 'Resin 🌲'] },
  { id: 'fodder', name: 'Fodder & Feed 🌾', examples: ['Lucerne 🌿', 'Berseem 🌿', 'Napier Grass 🌱', 'Maize Silage 🌽'] },
  { id: 'medicinal', name: 'Medicinal & Aromatic 🌿', examples: ['Aloe Vera 🌱', 'Tulsi 🌿', 'Ashwagandha 🌿', 'Lemongrass 🌱'] },
  { id: 'processed', name: 'Processed Agri 🥫', examples: ['Dehydrated Fruits 🍍', 'Fruit Pulp 🍑', 'Cold-Pressed Oils 🛢️', 'Flour 🌾', 'Spice Powders 🧂'] },
];

const MAIN_TABS = ['Primary', 'Secondary', 'Tertiary', 'New Innovation'];
const ACTIONS = ['Bulk Buy', 'Bulk Sell', 'Future Order', 'Price List', 'Suppliers'];

const packagingItems = {
  cereals: { primary: 'PP Bags 🛍️', secondary: 'Cardboard Boxes 📦', tertiary: 'Pallets 🏗️' },
  pulses: { primary: 'Polypropylene Bags 🛍️', secondary: 'Corrugated Boxes 📦', tertiary: 'Bulk Containers 🏗️' },
  oilseeds: { primary: 'Jute Bags 🛍️', secondary: 'Fiber Drums 📦', tertiary: 'Wooden Crates 🏗️' },
  fruits: { primary: 'Plastic Trays 🍇', secondary: 'Cardboard Cartons 📦', tertiary: 'Wooden Crates 🏗️' },
  vegetables: { primary: 'Plastic Trays 🥦', secondary: 'Corrugated Cartons 📦', tertiary: 'Wooden Crates 🏗️' },
  spices: { primary: 'Glass Jars 🧂', secondary: 'Cardboard Boxes 📦', tertiary: 'Bulk Containers 🏗️' },
  plantation: { primary: 'Gunny Bags 🛍️', secondary: 'Fiber Drums 📦', tertiary: 'Pallets 🏗️' },
  commercial: { primary: 'PP Bags 🛍️', secondary: 'Corrugated Boxes 📦', tertiary: 'Pallets 🏗️' },
  livestock: { primary: 'Milk Pouches 🥛', secondary: 'Cartons 📦', tertiary: 'Cold Storage 🏗️' },
  fisheries: { primary: 'Ice-packed Fish Bags 🐟', secondary: 'Styrofoam Boxes 📦', tertiary: 'Refrigerated Containers 🏗️' },
  forestry: { primary: 'Plastic Wrap 🌲', secondary: 'Wooden Crates 📦', tertiary: 'Bulk Containers 🏗️' },
  fodder: { primary: 'PP Bags 🛍️', secondary: 'Corrugated Boxes 📦', tertiary: 'Bulk Containers 🏗️' },
  medicinal: { primary: 'Glass Jars 🌿', secondary: 'Cardboard Boxes 📦', tertiary: 'Bulk Containers 🏗️' },
  processed: { primary: 'Plastic Pouches 🥫', secondary: 'Cartons 📦', tertiary: 'Pallets 🏗️' },
};

export default function AgriLinkPackaging() {
  const [mainTab, setMainTab] = useState(MAIN_TABS[0]);
  const [selectedCategoryId, setSelectedCategoryId] = useState(categories[0].id);
  const selectedCategory = useMemo(() => categories.find(c => c.id === selectedCategoryId), [selectedCategoryId]);
  const [selectedCommodity, setSelectedCommodity] = useState(selectedCategory.examples[0]);
  const [selectedAction, setSelectedAction] = useState(ACTIONS[0]);

  const currentPackaging = packagingItems[selectedCategoryId] || { primary: '', secondary: '', tertiary: '' };

  return (
    <div className="min-h-screen bg-gray-900 text-yellow-200 p-4 flex justify-center">
      <div className="w-full rounded-2xl shadow-lg bg-gray-800 p-4">
        
        {/* Header */}
        <h1 className="text-2xl font-bold text-center mb-4">Agri Packaging Hub</h1>

        {/* Main Tabs */}
        <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-6 gap-2 mb-4 border-b py-2 border-y-1 border-white place-items-center">
          {MAIN_TABS.map(t => (
            <button
              key={t}
              onClick={() => {
                setMainTab(t);
                setSelectedAction(ACTIONS[0]);
                setSelectedCategoryId(categories[0].id);
              }}
              className={`px-3 py-2 rounded-lg text-sm font-medium text-center transition-colors ${
                mainTab === t
                  ? 'bg-yellow-600 text-black shadow-md'
                  : 'bg-yellow-700 text-gray-200 hover:bg-yellow-500'
              }`}
            >
              {t}
            </button>
          ))}
        </div>

        {/* New Innovation Section */}
        {mainTab === 'New Innovation' && (
          <div className="mb-4">
            <h2 className="text-lg font-semibold mb-2 text-center">New Packaging Innovation</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 place-items-center">
              {[
                { type: 'Primary', item: 'PP Bags 🛍️', product: 'Rice 🍚', innovator: 'Sanjeev Kumar', country: 'India', unit: '50 kg', price: '₹2000', year: '2025', month: 'October' },
                { type: 'Secondary', item: 'Cardboard Boxes 📦', product: 'Wheat 🌾', innovator: 'Rina Patel', country: 'India', unit: '25 kg', price: '₹1200', year: '2025', month: 'September' },
                { type: 'Tertiary', item: 'Pallets 🏗️', product: 'Maize 🌽', innovator: 'Ajay Singh', country: 'USA', unit: '100 kg', price: '$50', year: '2024', month: 'December' },
              ].map((d, idx) => (
                <div key={idx} className="bg-gray-700 p-3 rounded-lg shadow-md">
                  <h3 className="font-semibold">{d.type} Packaging: {d.item}</h3>
                  <p><strong>Intended Product:</strong> {d.product}</p>
                  <p><strong>Innovator:</strong> {d.innovator}</p>
                  <p><strong>Country:</strong> {d.country}</p>
                  <p><strong>Unit:</strong> {d.unit}</p>
                  <p><strong>Price:</strong> {d.price}</p>
                  <p><strong>Year / Month:</strong> {d.year} / {d.month}</p>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Categories */}
        <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-6 gap-2 mb-2 place-items-center">
          {categories.map(c => (
            <button
              key={c.id}
              onClick={() => setSelectedCategoryId(c.id)}
              className={`px-3 py-2 rounded-lg text-sm font-medium text-center transition-colors ${
                selectedCategoryId === c.id
                  ? 'bg-yellow-600 text-black'
                  : 'bg-yellow-700 text-gray-200 hover:bg-yellow-500'
              }`}
            >
              {c.name}
            </button>
          ))}
        </div>

        {/* Commodities */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-2 mb-2 py-2 border-y-1 border-green-400 place-items-center">
          {selectedCategory.examples.map(ex => (
            <button
              key={ex}
              onClick={() => setSelectedCommodity(ex)}
              className={`px-3 py-2 rounded-lg text-sm font-medium text-center transition-colors ${
                selectedCommodity === ex
                  ? 'bg-yellow-600 text-black'
                  : 'bg-yellow-700 text-gray-200 hover:bg-yellow-500'
              }`}
            >
              {ex}
            </button>
          ))}
        </div>

        {/* Packaging Display */}
        <div className="space-y-2 mb-4">
          <div className="flex justify-between bg-gray-700 p-3 rounded-lg">
            <span className="font-medium">Primary:</span> {currentPackaging.primary}
          </div>
          <div className="flex justify-between bg-gray-700 p-3 rounded-lg">
            <span className="font-medium">Secondary:</span> {currentPackaging.secondary}
          </div>
          <div className="flex justify-between bg-gray-700 p-3 rounded-lg">
            <span className="font-medium">Tertiary:</span> {currentPackaging.tertiary}
          </div>
        </div>

        {/* Actions */}
        {mainTab !== 'Suppliers' && (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-2 mb-4 place-items-center">
            {ACTIONS.map(a => (
              <button
                key={a}
                onClick={() => setSelectedAction(a)}
                className={`px-3 py-2 rounded-lg text-sm font-medium text-center transition-colors ${
                  selectedAction === a
                    ? 'bg-yellow-600 text-black'
                    : 'bg-yellow-700 text-gray-200 hover:bg-yellow-500'
                }`}
              >
                {a}
              </button>
            ))}
          </div>
        )}

      </div>
    </div>
  );
}
